// @noflow
import './styles.css';

import { FormattedDate } from 'react-intl';
import PropTypes from 'prop-types';
import * as React from 'react';

const DayLabelsPropTypes = {
    dayLabels: PropTypes.arrayOf(
        PropTypes.shape({
            date: PropTypes.object.isRequired,
            style: PropTypes.object.isRequired
        })
    ).isRequired
};

const DayLabels = ({ dayLabels }) => {
    return (
        <div className="logs-timeline-component__day-labels">
            {dayLabels.map((label, i) => (
                <div className="logs-timeline-component__day-label" key={`day-${i}`} style={label.style}>
                    <div className="logs-timeline-component__day-label-date">
                        <FormattedDate day="numeric" month="short" value={label.date} weekday="short" year="numeric" />
                    </div>
                </div>
            ))}
        </div>
    );
};

DayLabels.propTypes = DayLabelsPropTypes;
export default DayLabels;



// WEBPACK FOOTER //
// ./src/components/widgets/logs-timeline/timeline/day-labels/index.js